import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(axios)
Vue.use(VueAxios)

export default {
  install(Vue) {
    Vue.prototype.$collegeRegistrationApiService = {
      college_registration_api_url: `${process.env.VUE_APP_MEMBER_API_URL}/college-registrations`,
      college_registration_api_token: process.env.VUE_APP_MEMBER_API_TOKEN,

      /**
       * 新增一筆佛學院報名資料
       * @param {Object} data - 報名資料（包含個資與科系選擇）
       * @returns {Object|null} - 回應資料或 null
       */
      async create(data) {
        const response = await axios.post(
          `${this.college_registration_api_url}`,
          data,
          { headers: { 'Authorization': `Bearer ${this.college_registration_api_token}` } }
        )

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
